export default __webpack_public_path__ + "static/media/4.567a8950.jpeg";